<template>
    <div>
        <b-navbar toggleable="xs" type="dark" variant="info" class="fixed-bottom px-0 py-0">
            <div class="navbar-toggler-wrapper">
                <b-navbar-toggle target="nav-collapse" style="color: #fff;"></b-navbar-toggle>
            </div>

                <!-- <b-navbar-brand to="/">Lionsclub </b-navbar-brand> -->

                

                <b-collapse id="nav-collapse" is-nav>
                    <b-navbar-nav>
                        <menu-item v-for="(r,i) in routes" :key="i" :route="r"></menu-item>
                        <b-nav-item @click="logout" v-if="loggedIn">Logout</b-nav-item>
                    </b-navbar-nav>

                    <!-- Right aligned nav items -->
                    <!-- <b-navbar-nav class="ml-auto">
                        <b-nav-item v-if="!loggedIn" to="login">Login</b-nav-item>
                        <b-nav-item v-else @click="logout">Logout</b-nav-item>
                    </b-navbar-nav> -->
                </b-collapse>

        </b-navbar>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
    name: "navbar",
    components: {
        MenuItem: () => import(/*webpackChunkName: "menu-item" */ "./MenuItem")
    },
    computed: {
        ...mapGetters('auth', ['loggedIn','isActivity', 'isMemberAdmin']),
        routes() {
            return this.$router.options.routes
        }
    },
    methods: {
        ...mapActions('auth', ['logout'])
    }
}
</script>